// extracted by mini-css-extract-plugin
module.exports = {"container":"select-account-age_container__t6zNN","title-mobile":"select-account-age_title-mobile__l6aQp","title":"select-account-age_title__V6F03"};